import { Typography, Grid, CardContent, CardMedia, Card, Container } from '@mui/material';

const cards = [
    { "src": "/images/n4.jpg", "title": "Fibre optic splicing" },
    { "src": "/images/e2.jpg", "title": "Fibre optic cable laying" },
    { "src": "/images/n7.jpg", "title": "Concrete crack repair" }
];

function ServiceWidget() {
    return (
        <Container>
            <Typography variant="h4" component="h4" gutterBottom align="center">
                Our Services
            </Typography>

            <Grid container spacing={4}>
                {cards.map((card) => (
                    <Grid item key={card.title} xs={12} sm={6} md={4}>
                        <Card
                            sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
                        >
                            <CardMedia
                                component="div"
                                sx={{
                                    // 16:9
                                    pt: '56.25%',
                                }}
                                image={card.src}
                            />
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    {card.title}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
}

export default ServiceWidget;